import './PageCommon.css';
import React, {useContext} from 'react';
import {NewsPage} from "./NewsPage";
import {useParams} from "react-router";
import { AppContext } from '../AppContext';

class ArticlePage extends NewsPage {
    constructor(props) {
        super(props);
        this.resource_type = 'article';
        this.componentDidUpdate({}, {}, {});
    }

    getResourceTypeDisplayName(form) {
        const forms = ['Sivu', 'Sivua', 'Sivut'];
        return forms[form];
    }
}

const ArticlePageWithContext = (props) => {
    const { uri } = useParams();
    const context = useContext(AppContext);
    let forceRedirect = null;
    switch (uri) {
        // Old Wordpress site URIs
        case 'counter-strike':
        case 'videot':
            forceRedirect = `/kategoria/${uri}`.replace('tag/', '');
            break;
        default:
            break;
    }
    if (forceRedirect) {
        window.location.href = forceRedirect;
    }
    if (!props?.uri) {
        props.uri = uri;
    }
    return (<ArticlePage {...props} context={context} />);
};

export default ArticlePageWithContext;
